import React, { Component, useEffect, useState } from "react";
import "./NavMenu.css";
import {
  Box,
  Button,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import DescriptionIcon from "@mui/icons-material/Description";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PeopleIcon from "@mui/icons-material/People";
import AnimationIcon from "@mui/icons-material/Animation";
import { menuItems } from "./menuItems";
const C = {
  s1: "temporary",
  s2: "persistent",
  permanent: "permanent",
};
export const NavMenu = ({ navigate }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [expandState, setExpandState] = React.useState({});
  const [variant, setVariant] = useState(() => {
    var v = localStorage.getItem("menu_variant");
    return v || C.s1;
  });
  useEffect(()=>{
    return () => {
      localStorage.setItem("menu_variant", variant)
    }
  },[variant]);
  function toggleDrawer(open, sender) {
    return (event) => {
      if (variant !== C.s1) {
        console.log("skip");
        return;
      }
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      console.log(sender, open);
      setDrawerOpen(open);
    };
  }
  function onExpandSw(title) {
    var newState = { ...expandState };
    newState[title] = !expandState[title];
    setExpandState(newState);
  }
  function onNavigate(path) {
    setDrawerOpen(false);
    navigate(path);
  }
  function isOpen(title) {
    return !expandState[title];
  }

  return (
    <div
      style={{
        backgroundColor: "aliceblue",
        minWidth: variant === C.s1 ? "50px" : "250px",
      }}
    >
      <Button onClick={toggleDrawer(true, "menu")}>
        <MenuIcon />
      </Button>
      <Drawer
        variant={variant}
        anchor={"left"}
        open={drawerOpen}
        onClose={toggleDrawer(false, "drawer")}
      >
        {/* <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton> */}
        <Box
          sx={{ width: 250 }}
          role="presentation"
          // onClick={toggleDrawer( false, "box1")}
          // onKeyDown={toggleDrawer( false, "box2")}
        >
          <List>
            <ListItem>
              <Typography variant="h5">{"Menu"}</Typography>
              {variant === C.permanent ? (
                <Button
                  onClick={() => {
                    setDrawerOpen(false);
                    setVariant(C.s1);
                  }}
                >
                  <PushPinOutlinedIcon />
                </Button>
              ) : (
                <Button onClick={() => setVariant(C.permanent)}>
                  <PushPinIcon />
                </Button>
              )}
            </ListItem>
            {menuItems.map((item, i) => {
              var { title, path, icon } = item;
              if (item.children) {
                return (
                  <div key={i}>
                    <ListItemButton onClick={() => onExpandSw(title)}>
                      <ListItemIcon>{icon}</ListItemIcon>
                      <ListItemText primary={title} />
                      {isOpen(title) ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={isOpen(title)} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.children.map((child, childIndex) => (
                          <ListItemButton
                            key={childIndex}
                            sx={{ pl: 4 }}
                            onClick={() => onNavigate(child.path)}
                          >
                            <ListItemIcon>{child.icon}</ListItemIcon>
                            <ListItemText primary={child.title} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </div>
                );
              } else {
                return (
                  <ListItem key={title} disablePadding>
                    <ListItemButton onClick={() => onNavigate(path)}>
                      <ListItemIcon>{icon}</ListItemIcon>
                      <ListItemText primary={title} />
                    </ListItemButton>
                  </ListItem>
                );
              }
            })}
          </List>
        </Box>
      </Drawer>
    </div>
  );
};
